import React from 'react';
import ProjectCard from './ProjectCard.jsx';

const ProjectList = ({ projects, onProjectUpdate }) => {
  return (
    <div className="projects-grid">
      {projects.map(project => (
        <ProjectCard 
          key={project.project_id} 
          project={project}
          onProjectUpdate={onProjectUpdate}
        />
      ))}
    </div>
  );
};

export default ProjectList;